export default __webpack_public_path__ + "static/media/1.e4f312b0.svg";